<script>
  import { favorite } from "../models/favorite.js";
  import Popup from "./Popup.svelte";

  export let product;
  export let showText = false;
  let faved = false;

  function isFavorite() {
    // this function isn't working appropriately for some reason
    return $favorite.products.some(x => x.id == product.id);
  }
</script>

{#if $favorite.errorMsg}
  <Popup message={$favorite.errorMsg} close={() => favorite.clearError()} />
{/if}

{#await $favorite}
{:then}
{#if showText}
<span><b>Like it? Favorite it!</b></span>
{/if}
<button
  class="btn btn-favorite btn-plain"
  class:faved={$favorite.products.some(x => x.id == product.id)}
  title={($favorite.products.some(x => x.id == product.id) ? 'Remove from' : 'Add to') + ' favorites'}
  on:click={favorite.toggle(product)}>
  <svg class="icon">
    {#if $favorite.products.some(x => x.id == product.id)}
      <use href={'/icons.svg#favorite'} />
    {:else}
      <use href={'/icons.svg#favorite_outline'} />
    {/if}
  </svg>
</button>
{/await}
